import React, { useEffect, useState } from "react";
import Header from "./Component/Header";
import NavBar from "./Component/NavBar";
import Footer from "./Component/Footer";
import Carousel from 'react-bootstrap/Carousel';
import { getDownloadURL, listAll, ref } from "firebase/storage";
import storage from "./firebase";
import LoadingSpinner from "./Component/LoadingSpinner";
import "./App.css"


const Home = () => {
    const [imageUrls, setImageUrls] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      setLoading(true);
      const imagesRef = ref(storage, "images");
      listAll(imagesRef)
        .then((res) => {
          const promises = res.items.map((item) => getDownloadURL(item));
          Promise.all(promises)
            .then((urls) => {
              const images = urls.map((url) => url );
              setImageUrls(images);
              setLoading(false);
            })
            .catch((error) => {
              console.error(error);
              setLoading(false);
            });
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    }, []);




    return (
        <>
            <Header />
            <div className=" h-100 p-2">
                <NavBar />
                <div className="row">
                    <div className="col text-center">
                        <div className="TabTitle text-center mt-4">
                            <b className="my_title fs-3">Home</b>
                        </div>
                    </div>
                </div>
                {/* <div className="row ">
                    <div class="col-md-7 align-items-center">
                        <div class="card-body p-md-1 mx-md-2">
                            <div class="col-lg-12 d-flex">
                                <div class="text-black px-2 py-2 p-md-10 mx-md-9">
                                    <div className="col-lg-10  float-left align-items-center"> */}
                <div class="row w-100 m-0 p-0">
                    <Carousel
                        interval={1500}
                        autoPlay
                    >
                        {imageUrls.map((data) => {
                            return (
                                <Carousel.Item key={data} style={{ height: '700px' }}>
                            
                                        <img class="d-block w-100 mt-3 mb-3" style={{ height: '700px' }} src={data} alt="Modern" />
                                    
                                  
                                <div class="row text-center">
                                  <Carousel.Caption>
                                    <h1 className="text-center">{data.caiption}</h1>
                                  </Carousel.Caption>
                                </div>
                              </Carousel.Item>

                            )
                        })}
                    </Carousel>

                </div>
                {/* </div></div></div></div></div>

                </div> */}
                {/* <div className="row m-3">
                    <div className="col">
                        <Card>Student Details</Card>
                    </div>
                    <div className="col">
                        <Card>Teacher Details</Card>
                    </div>
                </div> */}
                {
                    loading===true?
                    <LoadingSpinner />:<div></div>
                }

            </div >
            <Footer />
        </>
    );
};
export default Home;